import * as React from "react"
import { AsialWebsiteFooterBaseGrid as BaseGrid } from "../../hp-cms-module/_asial-websites-common/components/footer/AsialWebsiteFooterBaseGrid"
import { AsialWebsiteFooterPortal as Portal } from "../../hp-cms-module/_asial-websites-common/components/footer/AsialWebsiteFooterPortal"
import { AsialWebsiteFooterCopyright as Copyright } from "../../hp-cms-module/_asial-websites-common/components/footer/AsialWebsiteFooterCopyright"
import { AsialWebsiteFooterSitemap as Sitemap } from "../../hp-cms-module/_asial-websites-common/components/footer/AsialWebsiteFooterSitemap"

const Footer: React.FC = () => {
  return (
    <div style={{ fontSize: "10px" }}>
      <BaseGrid>
        <Portal />
      </BaseGrid>
      <BaseGrid>
        <Sitemap />
        <Copyright />
      </BaseGrid>
    </div>
  )
}

export default Footer
